<template>
  <button
    :class="['r-btn-C flx', btnSize, btnTypeClass]"
    :disabled="disabled || isProcessing"
    @click="disableClick"
    :style="{ backgroundColor: bgcolor || '' }"
  >
    <slot name="button">
      <h5>
        <slot>{{ title }}</slot>
      </h5>
    </slot>
  </button>
</template>
<script>
import { computed, ref } from "vue";
export default {
  props: {
    title: String,
    bgcolor: String,
    type: String,
    disabled: Boolean,
    size: {
      type: String,
      default: "small"
    },
    debounce: {
      type: Number,
      default: 500
    }
  },
  setup(props, { emit }) {
    const isProcessing = ref(false);
    
    const disableClick = e => {
      if (isProcessing.value) return;
      isProcessing.value = true;
      emit("click", e);
      setTimeout(() => {
        isProcessing.value = false;
      }, props.debounce);
    };
    const btnSize = computed(() => {
      if (props.size === "small") return "";
      else return props.size;
    });
    const btnTypeClass = computed(() => {
      if (props.type) {
        return `r-btn-${props.type}`;
      }
      return "";
    });
    return { disableClick, btnSize, btnTypeClass, isProcessing };
  }
};
</script>
<style>
.r-btn-C {
  display: flex;
  padding: 6px;
  background-color: rgb(0, 56, 160);
  border-radius: 6px;
  cursor: pointer;
  color: #fff;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin: 2px;
  border: none;
  font-weight: 400;
}
.r-btn-C.medium h5 {
  font-size: 13px;
}
.r-btn-C.large h5 {
  font-size: 14px;
  padding: 10px 16px;
}
.r-btn-C:disabled,
.r-btn-C:disabled:hover {
  background-color: rgb(226, 226, 226) !important;
}
.r-btn-C:focus {
  outline: none;
}
.r-btn-success {
  background-color: #28a745 !important;
}
.r-btn-success:hover {
  background-color: #218838 !important;
}
.r-btn-danger {
  background-color: #dc3545 !important;
}
.r-btn-danger:hover {
  background-color: #c82333 !important;
}
.r-btn-warning {
  background-color: #ffc107 !important;
  color: #212529 !important;
}
.r-btn-warning:hover {
  background-color: #e0a800 !important;
}
.r-btn-secondary {
  background-color: #6c757d !important;
}
.r-btn-secondary:hover {
  background-color: #5a6268 !important;
}
.r-btn-C:not(.r-btn-success):not(.r-btn-danger):not(.r-btn-warning):not(.r-btn-secondary):hover {
  background-color: rgb(233, 85, 0) !important;
}
</style>
